import {
  PointOfInterestView,
  RestaurantView,
  AccomodationView,
  ItineraryView,
  ItineraryDayView,
  ItineraryStepView,
  EventView,
  NewsItemView,
} from '@redturtle/iovisit-theme/components/Views';

export const IoVisitViews = (config) => {
  config.views.contentTypesViews = {
    ...config.views.contentTypesViews,
    PointOfInterest: PointOfInterestView,
    Restaurant: RestaurantView,
    Accomodation: AccomodationView,
    Itinerary: ItineraryView,
    ItineraryDay: ItineraryDayView,
    ItineraryStep: ItineraryStepView,
    Event: EventView,
    'News Item': NewsItemView,
  };
};
